<div class="row no-gutters">
    <div class="col-3">
        <mat-form-field class="custom-autocomplete" floatLabel="never">
            <input
                matInput
                autocomplete="off"
                #autocompleteInput
                type="text"
                placeholder="ex.+359"
                [matAutocomplete]="autocomplete"
                (input)="filterCodes($event)"
                (paste)="filterCodesOnPaste($event)"
                style="overflow: hidden"
            >
            <i class="fa fa-caret-down"></i>
            <mat-autocomplete
                #autocomplete="matAutocomplete"

                [panelWidth]="300"

                class="phone-autocomplete-panel"

                (optionSelected)="enterCode($event)"
                (opened)="onTouched && onTouched()"
            >
                <mat-option
                    *ngFor="let code of filteredCodes | async; trackBy: trackByCode"
                    [value]="code.value">
                    <div class="select-item">
                        <span [ngClass]="code.classes"></span>
                        <span class="select-value">{{code.label}}</span>
                    </div>
                </mat-option>
            </mat-autocomplete>
        </mat-form-field>
    </div>
    <div class="col-9">
        <mat-form-field class="app-input" [floatLabel]="asFormsControl().floatingLabelNever && 'never'">
            <input
                matInput
                #input
                placeholder="Phone"
                autocomplete="off"
                (input)="enterPhone($event)"
                (focus)="onTouched && onTouched()">
        </mat-form-field>
    </div>
</div>
<div *ngIf='asFormsControl().errors.length > 0' class="form-text text-danger">
    <span *ngFor="let error of asFormsControl().errors">{{error}}</span>
</div>
